import { Component } from "react";
import { Link } from "react-router-dom";
import { performSignOut } from "@/lib/auth-session";

export default class PlatformErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error("Platform console error", error, info);
  }

  render() {
    const { error } = this.state;
    if (error) {
      return (
        <div
          className="min-h-screen grid place-items-center p-8"
          style={{ background: "var(--bg-base)", color: "var(--text-primary)" }}
          data-testid="platform-error-fallback"
        >
          <div className="max-w-md text-center space-y-4">
            <h1 className="font-heading text-2xl font-medium">Platform console unavailable</h1>
            <p className="text-sm text-[var(--text-secondary)] leading-relaxed">
              Something went wrong loading the operator console. Try reloading, or sign in again.
            </p>
            <p className="text-xs font-mono text-[var(--text-tertiary)] break-all">{String(error?.message || error)}</p>
            <div className="flex flex-wrap justify-center gap-3 pt-2">
              <button type="button" className="btn-primary" onClick={() => window.location.reload()}>
                Reload
              </button>
              <button type="button" className="btn-secondary" onClick={() => performSignOut()}>
                Sign in again
              </button>
              <Link to="/admin" className="btn-ghost text-sm">
                Open /admin
              </Link>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
